import { useEffect, useState } from "react";
import i18n from "./i18n";
import { STRING_LANGUAGE_COMPRARTODO } from "../const/string-const";

export function useAppLanguage() {
    const [selectedLanguage, setSelectedLanguage] = useState(
        () => localStorage.getItem(STRING_LANGUAGE_COMPRARTODO) || i18n.language || "es"
    );
    const [isLanguageDropdownOpen, setIsLanguageDropdownOpen] = useState(false);

    useEffect(() => {
        const onLanguageChanged = (lng) => setSelectedLanguage(lng);
        i18n.on("languageChanged", onLanguageChanged);
        return () => i18n.off("languageChanged", onLanguageChanged);
    }, []);

    useEffect(() => {
        if (!isLanguageDropdownOpen) return undefined;

        const handleClickOutside = (event) => {
            if (!event.target.closest(".language-dropdown")) {
                setIsLanguageDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [isLanguageDropdownOpen]);

    return {
        selectedLanguage,
        setSelectedLanguage,
        isLanguageDropdownOpen,
        setIsLanguageDropdownOpen,
    };
}
